import { SELECT_STYLES } from 'helpers/formStyles';

/**
 * Shared Tailwind class strings for the PIF module (form/detail/print).
 * Input/select base styles come from the house pattern in helpers/formStyles.
 */
export { INPUT_CLS, TEXTAREA_CLS, SELECT_STYLES, TH_CLS, TD_CLS } from 'helpers/formStyles';

// Emphasized value text (replaces bootstrap `text-primary` on data values)
export const VALUE_CLS = 'tw-text-primary-600';

// Field labels
export const LABEL_CLS = 'tw-text-sm tw-text-slate-600';

// Validation error message under a field
export const ERROR_CLS = 'tw-text-xs tw-text-red-500 tw-mt-1 tw-mb-0';

// Native checkbox
export const CHECK_CLS = 'tw-w-4 tw-h-4 tw-rounded-sm tw-border-slate-300 tw-accent-blue-600 tw-cursor-pointer';

// Display-only checkbox (detail/print views): no `disabled` attribute — the
// browser renders disabled checks washed-out and hard to read. The controlled
// `checked` prop (no onChange) already freezes the value; pointer-events-none
// removes the interactive affordance while tw-accent keeps the tick vivid.
export const CHECK_DISPLAY_CLS = 'tw-w-4 tw-h-4 tw-rounded-sm tw-border-slate-300 tw-accent-blue-600 tw-pointer-events-none';

// Hand-built static tables
// TH_CLS / TD_CLS now live in helpers/formStyles (re-exported above).

// Accordion section body padding
export const SECTION_BODY_CLS = 'tw-p-3 tw-text-sm';

// react-select rendered inside a taiwincss Modal (dialog zIndex 100000):
// portal the menu to body and lift it above the dialog.
export const MODAL_SELECT_STYLES = {
  ...SELECT_STYLES,
  menuPortal: (base) => ({ ...base, zIndex: 100001 }),
};
